export default __webpack_public_path__ + "static/media/pic-404.b793311c.jpg";